import { getApi, gql } from '@wetransfer/transfer/apollo-api/src';
import { User } from '@wetransfer/transfer/types/graphql-types';

export const GET_ALL_SENT_TRANSFERS_IDS = gql`
  query getAllSentTransfersIds($teamId: ID!) {
    currentUser {
      team(teamId: $teamId) {
        sentTransfersIds
      }
    }
  }
`;

export const getAllSentTransfersIds = async (
  teamId: string
): Promise<{
  sentTransfersIds: string[];
}> => {
  const api = getApi();
  let currentUser: User;

  try {
    ({
      data: { currentUser },
    } = await api.query({
      query: GET_ALL_SENT_TRANSFERS_IDS,
      variables: { teamId },
      // Calling the `client.query` method causes the refetch for other active queries.
      // Usng the 'no-cache' policy makes it skip the cache and avoid that.
      fetchPolicy: 'no-cache',
    }));
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }

  if (currentUser === null || currentUser === undefined) {
    throw new Error('No transfer data returned');
  }

  return {
    sentTransfersIds: currentUser.team.sentTransfersIds,
  };
};
